<app-dp-detail-info [title]="'Zip Code Information'">
  <div class="detail-container">
    <div class="row">
      <div class="col-2 detail-label">Zip Code</div>
      <div class="col-4 detail-value">{{ zipCodeDetail?.zipcode }}</div>
    </div>
    <div class="row">
      <div class="col-2 detail-label">Partner</div>
      <div class="col-4 detail-value">{{ zipCodeDetail?.partner }}</div>
      <div class="col-2 detail-label">Update Date</div>
      <div class="col-3 detail-value">{{ zipCodeDetail?.auth?.updatedAt| date:'medium' }}</div>
      <div class="col-1">
        <button (click)="modalOpen()" *ngIf="isEditable" class="btn btn-dark" type="button">
          <font-awesome style="color:white">Edit</font-awesome>
        </button>
      </div>
    </div>
  </div>
  <div class="mb-24px"></div>

  <div class="d-flex flex-row justify-content-between">
    <div class="detail-info">
      <div class="h4 mb-16px">
        Store List
      </div>
    </div>
  </div>

  <div class="d-list">
    <div class="d-flex flex-column">
      <div class="dealer-table-wrapper w-100" style="position: absolute">
        <perfect-scrollbar>
          <table class="table table-list align-middle table-nowrap w-100">
            <thead>
            <tr>
              <th [attr.data-sort-fields]="'bpNo'">Store #</th>
              <th [attr.data-sort-fields]="'name'">Name</th>
              <th [attr.data-sort-fields]="'address'">Address</th>
            </tr>
            </thead>
            <tbody class="assigned-dealers">
            <tr *ngFor="let i = index; let store of storeList">
              <td>{{ store.bpNo }}</td>
              <td>{{ store.name }}</td>
              <td>
                {{ store.address?.address1 }}{{ store.address?.address2 ? ' ' + store.address?.address2 : '' }}
                , {{ store.address?.city }}, {{ store.address?.state }}, {{ store.address?.zipcode }}
              </td>
            </tr>
            </tbody>
          </table>
        </perfect-scrollbar>
        <div *ngIf="isEmpty" class="align-center container">
          <font-awesome [icon]="'fa-light fa-file-circle-exclamation'"></font-awesome>
          <span class="pl-14px">No Store</span>
        </div>
      </div>
    </div>
  </div>


</app-dp-detail-info>
